import { render, staticRenderFns } from "./SoftwareInstall.vue?vue&type=template&id=40e63883&scoped=true"
import script from "./SoftwareInstall.vue?vue&type=script&lang=js"
export * from "./SoftwareInstall.vue?vue&type=script&lang=js"
import style0 from "./SoftwareInstall.vue?vue&type=style&index=0&id=40e63883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e63883",
  null
  
)

export default component.exports